import lightIconColors from '../DesignSystem/icon/light'
import lightFontColors from '../DesignSystem/font/fontColors/light'
import newColors from '../DesignSystem/colors/index'
import lightSurfaceColors from '../DesignSystem/surface/light'
import lightBorderColors from '../DesignSystem/border/light'
import ThemeInterface from './ThemeInterface'

const themeName = 'light'

// TODO: Change names of colors which are the same on light and dark mode
// The color thme is based on Material Design baseline palette: https://material.io/design/color/dark-theme.html#ui-application
export const colors = {
    ...newColors,
    // Standard colors
    onyx: '#000000',
    'onyx-2': '#000000',
    'onyx-3': '#000000',
    'onyx-4': '#000000',
    'onyx-5': '#000000',

    pearl: '#FFFFFF',
    'pearl-2': '#FFFFFF',
    'pearl-3': '#FFFFFF',
    'pearl-4': '#FFFFFF',

    basra: '#404040',

    keshi: '#777777',
    'keshi-2': '#777777',
    'keshi-3': '#777777',
    'keshi-4': '#777777',

    moon: '#E5E5E5',
    'moon-2': '#E5E5E5',
    'moon-3': '#E5E5E5',
    'moon-4': '#E5E5E5',
    'moon-5': '#E5E5E5',

    tahitian: '#F5F5F5',
    'tahitian-2': '#F5F5F5',
    'tahitian-3': '#F5F5F5',
    'tahitian-4': '#F5F5F5',
    'tahitian-5': '#F5F5F5',

    // Special Colors
    'onyx-opacity-12': 'rgba(0, 0, 0, 0.12)',
    'onyx-opacity-50': 'rgba(0, 0, 0, 0.5)',
    'onyx-opacity-70': 'rgba(0, 0, 0, 0.7)',
    'pearl-opacity-35': 'rgba(255, 255, 255, 0.35)',
    'pearl-opacity-70': 'rgba(255, 255, 255, 0.7)',
    amber: '#00000000',

    // Fixed Colors
    BLACK: '#000000',
    WHITE: '#FFFFFF',
    GRAY16: '#282828',
    GRAY25: '#404040',
    GRAY50: '#808080',
    GRAY66: '#A8A8A8',
    GRAY90: '#E5E5E5',
    GRAY96: '#F5F5F5',

    ORANGE: '#F6A800',
    YELLOW: '#FEDE00',
    LIGHTGREEN: '#32CD30',
    GREEN: '#0A7029',
    LIGHTBLUE: '#4285F4',
    BLUE: '#003F94',
    RED: '#F51720',

    TRANSPARENT: '#00000000',
    'WHITE-OPACITY-70': 'rgba(255, 255, 255, 0.7)',
}

const fontFamily = 'Sport1-Regular'

const fontFamilyBold = 'Sport1-Bold'

const fontFamilyCondesedItalic = 'Sport1-CondensedBlackItalic'

const fontSizes = {
    FS10: '10px',
    FS11: '11px',
    FS12: '12px',
    FS14: '14px',
    FS15: '15px',
    FS16: '16px',
    FS18: '18px',
    FS20: '20px',
    FS22: '22px',
    FS28: '28px',
    FS30: '30px',
    FS36: '36px',
    FS48: '48px',
} as const

const lineHeights = {
    LH14: '14px',
    LH16: '16px',
    LH20: '20px',
    LH22: '22px',
    LH24: '24px',
    LH30: '30px',
    LH34: '34px',
    LH36: '36px',
    LH58: '58px',
} as const

// space is used for margin and padding scales
// it's recommended to use powers of two to ensure alignment
// when used in nested elements
// numbers are converted to px
const space = [0, 2, 4, 8, 12, 16, 24, 32, 40]

// radii is used for border-radius scales
// numbers are converted to radii
const radii = [0, 2, 4, 6, 8, 10, 11, 12, 16]

const lightTheme: ThemeInterface = {
    themeName,
    colors,
    space,
    radii,
    fontFamily,
    fontFamilyBold,
    fontFamilyCondesedItalic,
    fontSizes,
    lineHeights,
    fontColors: lightFontColors,
    iconColors: lightIconColors,
    surfaceColors: lightSurfaceColors,
    borderColors: lightBorderColors,
}

export default lightTheme
